import { Component, Inject, Input, OnChanges, OnInit, Optional, SimpleChanges } from '@angular/core';
import { ModalService } from '@app/core/services/modal.service';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { GetTransportAreaPostplacesMoveParams, TransportAreaItem, TransportAreaPostplacesMoveGet, TransportAreaService } from '@app/services/transport-area.service';

@Component({
    selector: 'tt-transport-area-pp-move',
    templateUrl: './transport-area-pp-move.component.html',
    styleUrls: ['./transport-area-pp-move.component.css'],
})
export class TransportAreaPpMoveComponent implements OnInit, OnChanges {
    @Input()
    public params?: GetTransportAreaPostplacesMoveParams;

    public page?: TransportAreaPostplacesMoveGet;

    public transportAreas: TransportAreaItem[] = [];

    public moving = false;

    public get movingDisabled(): boolean {
        return !this.page || this.page.transportarea_move_from_keyno == this.page.transportarea_move_to_keyno || +this.page.transportarea_move_to_keyno < 0;
    }

    constructor(
        private transportArea: TransportAreaService,
        private modal: ModalService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) {
        this.navigator = useNavigatorFor(navigator, this);
    }

    public async move() {
        if (!this.page) return;

        try {
            this.moving = true;

            const { errorcode, errormessage } = await this.transportArea.moveTransportAreaPostplaces(this.page);

            if ('' + errorcode !== '0') {
                this.modal.show({ type: 'warning', title: 'error', translateTitle: true, message: errormessage });
            } else {
                this.navigator?.back();
            }
        } catch (error) {
            console.error(error);
        } finally {
            this.moving = false;
        }
    }

    private async loadGet() {
        if (!!this.params) {
            this.page = await this.transportArea.getTransportAreaPostplacesMove(this.params);
        }
    }

    private async loadTransportAreas() {
        if (!!this.params) {
            this.transportAreas = await this.transportArea.getTransportAreaItems(this.params);
        }
    }

    private async init() {
        this.loadGet();
        this.loadTransportAreas();
    }

    ngOnInit(): void {
        if (!!this.navigator) {
            this.navigator.setSize?.({ width: '60rem' });
            this.navigator.setHeading?.('p2_m_transportareappmove', true);
            this.params = this.navigator.params as any;
            this.init();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['params']) {
            this.init();
        }
    }
}
